module.exports = __webpack_public_path__ + "static/media/backgroundImg.a2647e87.jpg";